import React from "react";

import { cn } from "../../handlers/cn.utils";

function Accordion({ label, children, errorStatus, className = "" }) {
	const [showContent, setShowContent] = React.useState(false);
	return (
		<div className={cn(`${errorStatus && "border-danger"} rounded border-2 p-2`, className)}>
			<div className="accordion-item">
				<p
					className={`accordion-header m-0 p-0 font-bold text-gray-500 ${showContent ? "mb-3" : "collapsed"}`}
					onClick={() => setShowContent(!showContent)}
				>
					{label}
				</p>
				{showContent && <div className="accordion-body">{children}</div>}
			</div>
		</div>
	);
}

export default Accordion;
